import { EPAYMENT_TYPES } from "@constants";
import { IPayer } from "../interface/IManageCards";

export interface IPaymentMethodResponse {
    cardholderName: string;
    default: boolean;
    expirationDate: string;
    partialDigits: string;
    paymentMethodId: number;
    paymentMethodType: EPAYMENT_TYPES;
    type: string;
}

export interface IPayerResponse {
    payerContactUuid: string;
    payerRef: string;
    paymentMethods: IPaymentMethodResponse[];
}

export const getResponseToState = (response: IPayerResponse): IPayer => ({
    payerContactUuid: response.payerContactUuid,
    payerRef: response.payerRef,
    paymentMethods: response.paymentMethods.map((paymentMethod) => ({
        cardholderName: paymentMethod.cardholderName,
        default: paymentMethod.default,
        expirationDate: paymentMethod.expirationDate,
        partialDigits: paymentMethod.partialDigits,
        paymentMethodId: paymentMethod.paymentMethodId,
        paymentMethodType: paymentMethod.paymentMethodType,
        type: paymentMethod.type,
    })),
});
